import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageLoginToken = lazy(() => import("./layout/index"));

export const routerPageLoginToken: RouterItemType = {
  path: "/login-token",
  authorize: false,
  localization: false,
  element: <LayoutPageLoginToken />,
};
